import { render, staticRenderFns } from "./custom-type1.vue?vue&type=template&id=9ca02af8&scoped=true"
import script from "./custom-type1.vue?vue&type=script&lang=js"
export * from "./custom-type1.vue?vue&type=script&lang=js"
import style0 from "./custom-type1.vue?vue&type=style&index=0&id=9ca02af8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ca02af8",
  null
  
)

export default component.exports